<template>
  <div class="scans-page scrollable">
    <div class="page-header">
      <h1>Monitor</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>Monitor</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
<!--    <div style="margin: 20px 0">-->
<!--      <el-button type="success" @click="horizonContinue" plain>Horizon continue</el-button>-->
<!--      <el-button type="warning" @click="horizonPause" plain>Horizon pause</el-button>-->
<!--      <el-button type="danger"  @click="horizonTerminate" plain>Horizon terminate</el-button>-->
<!--    </div>-->
    <div style="margin: 20px 0">
      <el-button type="warning" @click="queueFlush" plain>Flush failed jobs</el-button>
      <el-button type="danger"  @click="queueRestart" plain>Queue restart</el-button>
    </div>
    <el-tabs type="border-card">
      <el-tab-pane label="Stats" group="">
        <stats page-label="stats" />
      </el-tab-pane>
      <el-tab-pane label="Recent Jobs" group="">
        <recent-jobs page-label="recent-jobs" />
      </el-tab-pane>
      <el-tab-pane label="Failed Jobs" group="">
        <failed-jobs page-label="failed-jobs" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Stats from '@/components/Monitor/Stats';
import RecentJobs from "@/components/Monitor/RecentJobs";
import FailedJobs from "@/components/Monitor/FailedJobs";
export default {
  name: "Monitor",
  components: {
    Stats,
    RecentJobs,
    FailedJobs,
  },
  data(){
    return {
      countNets: 50,
      countScansOptions: [
        {value: 10},
        {value: 25},
        {value: 50},
        {value: 100},
      ],}
  },
  mounted() {
    this.$store.commit('monitor/RESET_INITIAL_LOAD');
    this.$store.commit('monitor/RESET_SHOWN_ERRORS');
  },
  beforeDestroy() {
    this.$store.commit('monitor/SET_INITIAL_LOAD_COMPLETE');
    this.$store.commit('monitor/RESET_SHOWN_ERRORS');
  },
  methods:{
    horizonTerminate(){
      this.$store.dispatch('monitor/sentBash','horizon:terminate');
    },
    horizonPause(){
      console.log('pause');
    },
    horizonContinue(){
      console.log('continue');
    },

    //    queue:clear        Clear all queued jobs, by deleting all pending jobs.
    // queue:failed       List all of the failed queue jobs
    // queue:flush        Flush all of the failed queue jobs
    // queue:forget       Delete a failed queue job
    // queue:listen       Listen to a given queue
    // queue:restart      Restart queue worker daemons after their current job
    // queue:retry        Retry a failed queue job
    // queue:work         Start processing jobs on the queue as a daemon
    queueRestart(){
      this.$store.dispatch('monitor/sentBash',{'command':'queue:restart'});
    },
    queueFlush(){
      this.$store.dispatch('monitor/sentBash',{'command':'queue:flush'});
    },

  }
}
</script>

<style >
.el-row {
  margin-bottom: 20px;

}
.el-row:last-child {
   margin-bottom: 0;
 }

.el-col {
  border-radius: 5px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 5px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>